module.exports = __webpack_public_path__ + "frontStatic/img/completed.5e9210ac.png";